import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';

@Injectable()
export class VoucherServiceService {

  constructor(private http:HttpClient) { }

  getVouchers(v_id: string, cate: string):Observable<any>{
    // let url = 'https://dev.vecport.net/api/vectron-crm/public/api/voucher';
    let url = environment.api + 'voucher'
    let params = new HttpParams()
    .set('hash', v_id)
    .set('category', cate);

    return this.http.get(url, {params});
  }

}
